import { Notification, NotificationAction } from '@app/components/various/Notification';
import { getDeliveryWindowNamesCombined } from '@app/logic/Orders';
import { isEmpty } from '@app/utils/isEmpty';
import { DeliveryWindow, Order } from '@typings';
import { useTranslation } from 'react-i18next';

import { useOrderProductsContext } from '../OrderProducts/OrderProductsContext';

interface Props {
  orderProductInfo: Order.Product;
  cancelledVariants: Order.Product[];
  expiredDeliveryWindows: DeliveryWindow.Mixed[];
  expiredVariants: Order.Product[];
  removeCancelledVariants: VoidFunction;
  removeExpiredVariants: VoidFunction;
}

export const OrderProductAlerts = ({
  orderProductInfo,
  expiredDeliveryWindows,
  expiredVariants,
  removeCancelledVariants,
  removeExpiredVariants,
  cancelledVariants,
}: Props) => {
  const { t } = useTranslation(['expiredDelwins', 'confirmationConfig', 'orders', 'products', 'cancelled']);
  const { sortByByDeliveryWindow } = useOrderProductsContext();
  const showCancelledVariants = !isEmpty(cancelledVariants);
  const showExpiredDeliveryWindowAlert = !sortByByDeliveryWindow && !isEmpty(expiredDeliveryWindows);
  const showAlerts = showCancelledVariants || showExpiredDeliveryWindowAlert || orderProductInfo.added;

  if (!showAlerts) {
    return null;
  }

  return (
    <div className="space-y-2 pb-5">
      {showCancelledVariants && (
        <Notification isBordered type="warning" message={t('cancelled:variants_cancelled', { count: cancelledVariants.length })}>
          <NotificationAction onClick={removeCancelledVariants}>
            {t('confirmationConfig:remove_unavailable_variants_from_order.title', { count: cancelledVariants.length })}
          </NotificationAction>
        </Notification>
      )}
      {showExpiredDeliveryWindowAlert && (
        <Notification
          isBordered
          type="warning"
          message={t('expiredDelwins:delivery_window_has_expired', {
            count: expiredDeliveryWindows.length,
            name: getDeliveryWindowNamesCombined(expiredDeliveryWindows),
          })}
        >
          <NotificationAction onClick={removeExpiredVariants}>
            {t('confirmationConfig:remove_unavailable_variants_from_order.title', { count: expiredVariants.length })}
          </NotificationAction>
        </Notification>
      )}
      {orderProductInfo.added && <Notification isBordered type="info" message={t('products:product_added')} />}
    </div>
  );
};
